module dg.objects {

    function amount($filter: ng.IFilterService): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel'],
            template: '<input type="text" class="form-control" />',
            //replace: true,
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrls) => {
                var ngModel: ng.INgModelController = ctrls[0];
                ngModel.$formatters.push((value: number) => {
                    //TODO: use formatting service and metadata for the number format
                    return $filter('number')(value, 2);
                });
            }
        };
    }
    amount.$inject = [
        '$filter'
    ];

    angular.module('dg.objects')
        .directive('amount', amount);
} 